export default __webpack_public_path__ + "static/media/exchange logo.940e54e8.svg";